export default "__VITE_ASSET__8896212b__"